import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
// import { orderExport } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'
import { OrderExport } from 'depoto-core'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class OrderExportService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  // public async getorderExport(id): Promise<orderExport> {
  //     return new orderExport(
  //         await this.core.services.orderExport.getById(id, {
  //             // todo
  //             id: null,
  //         })
  //     )
  // }

  async getOrderExport(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: OrderExport[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.orderExport.getList(parameters, schema)
  }

  // createCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {
  //     return this.core.services.checkout.createWithTanstack(checkout, schema)
  // }

  // updateCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {y
  //     return this.core.services.checkout.updateWithTanstack(checkout, schema)
  // }

  // deleteorderExport(orderExport: Partial<orderExport>): Promise<orderExport> {todo
  //   return this.core.services.orderExport.dele(orderExport)
  // }
}
